<template>
    <!-- 8. 底部版权区 - 高级精简版 -->
    <div class="footer">
        <!-- 背景装饰 -->
        <div class="footer-bg-effects">
            <div class="gradient-orb left"></div>
            <div class="gradient-orb right"></div>
            <div class="grid-lines"></div>
        </div>

        <div class="container footer-content">
            <!-- 主Logo与Slogan -->
            <div class="footer-brand">
                <div class="brand-logo">
                    <i class="el-icon-cloudy"></i>
                    <span>智步云上模型网</span>
                </div>
                <p class="brand-slogan">Digital Twin Asset Marketplace</p>
            </div>

            <!-- 核心导航链接 - 5个保留项 -->
            <nav class="footer-nav-advanced">
                <div class="nav-item" @click="platformIntro">
                    <div class="nav-icon">
                        <i class="el-icon-info"></i>
                    </div>
                    <span class="nav-text">平台介绍</span>
                    <div class="nav-glow"></div>
                </div>

                <div class="nav-divider"></div>

                <div class="nav-item" @click="contactUs">
                    <div class="nav-icon">
                        <i class="el-icon-message"></i>
                    </div>
                    <span class="nav-text">联系我们</span>
                    <div class="nav-glow"></div>
                </div>

                <div class="nav-divider"></div>

                <div class="nav-item highlight" @click="handleDesignerCertify">
                    <div class="nav-icon">
                        <i class="el-icon-medal"></i>
                    </div>
                    <span class="nav-text">加入我们</span>
                    <div class="nav-glow"></div>
                </div>

                <div class="nav-divider"></div>

                <div class="nav-item" @click="platformNews">
                    <div class="nav-icon">
                        <i class="el-icon-news"></i>
                    </div>
                    <span class="nav-text">平台动态</span>
                    <div class="nav-glow"></div>
                </div>

                <div class="nav-divider"></div>

                <div class="nav-item warning" @click="report">
                    <div class="nav-icon">
                        <i class="el-icon-warning-outline"></i>
                    </div>
                    <span class="nav-text">模型举报</span>
                    <div class="nav-glow"></div>
                </div>
            </nav>

            <!-- 微信二维码精简版 -->
            <div class="footer-social">
                <div class="qrcode-container">
                    <img src="@/assets/erweima.png" alt="官方微信" />
                    <div class="qrcode-overlay">
                        <i class="el-icon-chat-dot-round"></i>
                    </div>
                    <div class="scan-line"></div>
                </div>
                <span class="social-label">添加官方微信</span>
            </div>

            <!-- 版权信息 - 添加装饰分隔 -->
            <div class="copyright-section">
                <div class="copyright-divider">
                    <span class="line"></span>
                    <i class="el-icon-cpu"></i>
                    <span class="line"></span>
                </div>
                <div class="copyright-text">
                    <p>北京智步云上科技有限公司 All rights reserved</p>
                    <div class="license-tags">
                        <span class="tag">备案/许可证编号：京ICP备2024066658号</span>
                        <span class="separator">|</span>
                        <span class="tag">增值电信业务经营许可证：京B2-20253172</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    inject: ['reload'],
    data() {
        return {
            token: localStorage.getItem('token'),
        }
    },
    methods: {
        report() {
            const routeInfo = this.$router.resolve({
                path: '/report',
            });
            window.open(routeInfo.href, '_blank');
        },
        platformIntro() {
            const routeInfo = this.$router.resolve({
                path: '/platformIntro',
            });
            window.open(routeInfo.href, '_blank');
        },
        contactUs() {
            const routeInfo = this.$router.resolve({
                path: '/contactUs',
            });
            window.open(routeInfo.href, '_blank');
        },
        handleDesignerCertify() {
            if (this.token) {
                const routeInfo = this.$router.resolve({
                    path: '/dashboard/seller/info',
                });
                window.open(routeInfo.href, '_blank');
            } else {
                this.$message.warning('请先登录后再进行认证操作');
                localStorage.removeItem('userData');
                localStorage.removeItem('token');
                this.$router.push('/login');
                return;
            }
        },
        platformNews() {
            const routeInfo = this.$router.resolve({
                path: '/platformNews',
            });
            window.open(routeInfo.href, '_blank');
        },
    },
}
</script>

<style lang="less" scoped>
// 深色科技风格主题色定义
@base-deep: #0a0e17;
@base-darker: #050810;
@primary: #06b6d4; // 青色科技风
@primary-light: #67e8f9;
@accent-gold: #f59e0b; // 金色强调
@text-primary: #f9fafb;
@text-secondary: #9ca3af;
@border-color: rgba(255, 255, 255, 0.08);
@warning-color: #ef4444;

.footer {
    background: linear-gradient(180deg, @base-deep 0%, @base-darker 100%);
    color: @text-secondary;
    padding: 80px 0 40px;
    position: relative;
    overflow: hidden;
    border-top: 1px solid @border-color;
}

// 背景装饰效果
.footer-bg-effects {
    position: absolute;
    inset: 0;
    pointer-events: none;
    overflow: hidden;

    .gradient-orb {
        position: absolute;
        width: 400px;
        height: 400px;
        border-radius: 50%;
        filter: blur(100px);
        opacity: 0.08;

        &.left {
            background: @primary;
            top: -200px;
            left: -100px;
        }

        &.right {
            background: @accent-gold;
            bottom: -200px;
            right: -100px;
        }
    }

    .grid-lines {
        position: absolute;
        inset: 0;
        background-image:
            linear-gradient(rgba(6, 182, 212, 0.03) 1px, transparent 1px),
            linear-gradient(90deg, rgba(6, 182, 212, 0.03) 1px, transparent 1px);
        background-size: 50px 50px;
        mask-image: radial-gradient(circle at center, black 30%, transparent 80%);
    }
}

.footer-content {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 24px;
    position: relative;
    z-index: 2;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 48px;
}

// 品牌区域
.footer-brand {
    text-align: center;
    animation: fade-in-down 0.8s ease-out;

    .brand-logo {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 12px;
        font-size: 28px;
        font-weight: 800;
        color: @text-primary;
        margin-bottom: 8px;

        i {
            font-size: 32px;
            color: @primary;
            filter: drop-shadow(0 0 10px rgba(6, 182, 212, 0.5));
        }
    }

    .brand-slogan {
        font-size: 14px;
        letter-spacing: 4px;
        text-transform: uppercase;
        color: @text-secondary;
        opacity: 0.8;
    }
}

@keyframes fade-in-down {
    from {
        opacity: 0;
        transform: translateY(-20px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

// 高级导航样式
.footer-nav-advanced {
    display: flex;
    align-items: center;
    gap: 16px;
    flex-wrap: wrap;
    justify-content: center;
}

.nav-item {
    position: relative;
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 24px;
    background: rgba(255, 255, 255, 0.02);
    border: 1px solid @border-color;
    border-radius: 50px;
    cursor: pointer;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    overflow: hidden;

    .nav-icon {
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(6, 182, 212, 0.1);
        border-radius: 50%;
        color: @primary;
        font-size: 16px;
        transition: all 0.3s;
    }

    .nav-text {
        font-size: 15px;
        font-weight: 500;
        color: @text-secondary;
        transition: all 0.3s;
    }

    .nav-glow {
        position: absolute;
        inset: 0;
        background: radial-gradient(circle at 50% 50%, rgba(6, 182, 212, 0.15), transparent 70%);
        opacity: 0;
        transition: opacity 0.3s;
    }

    &:hover {
        border-color: rgba(6, 182, 212, 0.3);
        transform: translateY(-2px);
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);

        .nav-icon {
            background: @primary;
            color: #fff;
            transform: scale(1.1);
            box-shadow: 0 0 15px rgba(6, 182, 212, 0.4);
        }

        .nav-text {
            color: @text-primary;
        }

        .nav-glow {
            opacity: 1;
        }
    }

    // 特殊样式：加入我们（高亮）
    &.highlight {
        border-color: rgba(245, 158, 11, 0.3);

        .nav-icon {
            background: rgba(245, 158, 11, 0.1);
            color: @accent-gold;
        }

        .highlight-badge {
            position: absolute;
            top: -8px;
            right: -8px;
            background: linear-gradient(135deg, #ef4444, #f59e0b);
            color: #fff;
            font-size: 10px;
            font-weight: 700;
            padding: 2px 8px;
            border-radius: 10px;
            animation: pulse-badge 2s infinite;
        }

        &:hover {
            border-color: rgba(245, 158, 11, 0.5);
            box-shadow: 0 10px 30px rgba(245, 158, 11, 0.15);

            .nav-icon {
                background: @accent-gold;
                color: #fff; // 新增：确保图标变白
                box-shadow: 0 0 15px rgba(245, 158, 11, 0.4);
            }
        }
    }

    // 特殊样式：举报（警告色）
    &.warning {
        .nav-icon {
            color: @warning-color;
            background: rgba(239, 68, 68, 0.1);
        }

        &:hover .nav-icon {
            background: @warning-color;
            color: #fff; // 新增：确保图标变白
            box-shadow: 0 0 15px rgba(239, 68, 68, 0.4);
        }
    }
}

@keyframes pulse-badge {

    0%,
    100% {
        transform: scale(1);
    }

    50% {
        transform: scale(1.05);
    }
}

.nav-divider {
    width: 4px;
    height: 4px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 50%;
}

// 社交区域
.footer-social {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;

    .qrcode-container {
        position: relative;
        width: 100px;
        height: 100px;
        border-radius: 12px;
        overflow: hidden;
        border: 1px solid @border-color;
        background: rgba(255, 255, 255, 0.05);
        cursor: default; // 明确显示不可点击
        transition: all 0.4s;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            display: block; // 消除底部间隙
        }

        // 边框发光效果（不遮挡内容）
        &::before {
            content: '';
            position: absolute;
            inset: 0;
            border-radius: 12px;
            padding: 1px; // 内边框
            background: linear-gradient(135deg, rgba(6, 182, 212, 0.6), rgba(245, 158, 11, 0.3), rgba(6, 182, 212, 0.6));
            -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
            mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
            -webkit-mask-composite: xor;
            mask-composite: exclude;
            opacity: 0;
            transition: opacity 0.3s;
            z-index: 2;
            pointer-events: none;
        }

        // 四角装饰（科技感）
        &::after {
            content: '';
            position: absolute;
            inset: 0;
            background:
                linear-gradient(90deg, @primary 2px, transparent 2px) 0 0,
                linear-gradient(180deg, @primary 2px, transparent 2px) 0 0,
                linear-gradient(270deg, @primary 2px, transparent 2px) 100% 0,
                linear-gradient(180deg, @primary 2px, transparent 2px) 100% 0,
                linear-gradient(90deg, @primary 2px, transparent 2px) 0 100%,
                linear-gradient(0deg, @primary 2px, transparent 2px) 0 100%,
                linear-gradient(270deg, @primary 2px, transparent 2px) 100% 100%,
                linear-gradient(0deg, @primary 2px, transparent 2px) 100% 100%;
            background-size: 8px 8px;
            background-repeat: no-repeat;
            opacity: 0;
            transition: all 0.3s;
            z-index: 3;
            pointer-events: none;
        }

        // 扫描线动画（从下到上，不遮挡中间二维码）
        .scan-line {
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0; // 从底部开始
            height: 2px;
            background: linear-gradient(90deg, transparent, @primary-light, transparent);
            box-shadow: 0 0 8px @primary-light, 0 0 20px rgba(6, 182, 212, 0.5);
            opacity: 0;
            animation: scan-up 2s ease-in-out infinite;
            z-index: 4;
            pointer-events: none;
        }

        @keyframes scan-up {
            0% {
                bottom: 0;
                opacity: 0;
            }

            10% {
                opacity: 1;
            }

            90% {
                opacity: 1;
            }

            100% {
                bottom: 100%;
                opacity: 0;
            }
        }

        // 悬停效果：边框发光 + 四角显示 + 扫描线启动
        &:hover {
            transform: translateY(-4px) scale(1.05);
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);

            &::before {
                opacity: 1; // 显示渐变边框
            }

            &::after {
                opacity: 1; // 显示四角
            }

            .scan-line {
                opacity: 1; // 启动扫描线
            }
        }
    }

    .social-label {
        font-size: 13px;
        color: @text-secondary;
        letter-spacing: 2px;
        margin-top: 4px;
    }
}

// 版权区域 - 高级样式
.copyright-section {
    width: 100%;
    text-align: center;
}

.copyright-divider {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
    margin-bottom: 24px;
    color: rgba(255, 255, 255, 0.3);

    .line {
        width: 100px;
        height: 1px;
        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    }

    i {
        font-size: 20px;
        animation: rotate-slow 10s linear infinite;
    }
}

@keyframes rotate-slow {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}

.copyright-text {
    p {
        font-size: 14px;
        color: @text-secondary;
        margin-bottom: 12px;
        letter-spacing: 1px;
    }

    .license-tags {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 16px;
        font-size: 12px;
        color: rgba(255, 255, 255, 0.4);

        .tag {
            padding: 4px 12px;
            background: rgba(255, 255, 255, 0.03);
            border: 1px solid rgba(255, 255, 255, 0.08);
            border-radius: 4px;
            transition: all 0.3s;

            &:hover {
                background: rgba(6, 182, 212, 0.1);
                border-color: rgba(6, 182, 212, 0.3);
                color: @primary-light;
            }
        }

        .separator {
            color: rgba(255, 255, 255, 0.2);
        }
    }
}

// 响应式适配
@media (max-width: 768px) {
    .footer {
        padding: 60px 0 30px;
    }

    .footer-content {
        gap: 36px;
    }

    .footer-brand {
        .brand-logo {
            font-size: 22px;

            i {
                font-size: 26px;
            }
        }
    }

    .footer-nav-advanced {
        flex-direction: column;
        gap: 12px;
        width: 100%;
        max-width: 300px;
    }

    .nav-item {
        width: 100%;
        justify-content: flex-start;
        padding: 14px 20px;
    }

    .nav-divider {
        display: none;
    }

    .copyright-divider {
        .line {
            width: 60px;
        }
    }

    .license-tags {
        flex-direction: column;
        gap: 8px !important;

        .separator {
            display: none;
        }
    }
}
</style>